import React from 'react';
import SecondaryTitle from "../../../Components/SecondaryTitle";
import FormInput from "../../../Components/Forms/FormInput";
import {
    ISA_TYPES,
    PHONE_PREFIX_OPTIONS,
    SE_BE_TERMS_AND_CONDITIONS,
    SE_PRIVACY_POLICY,
    TITLE_OPTIONS
} from "../../../constants";
import Error from "../../../Components/Forms/Error";
import Checkbox from "../../../Components/Forms/Inputs/Checkbox";

const Details = (props) => {
    const {
        data = {
            'title':                                '',
            'first_name':                           '',
            'last_name':                            '',
            'account_type':                         '',
            'phone_prefix':                         '',
            'phone_number':                         '',
            'email':                                '',
            'service_mail_email_phone_sms_opt_in':     0,
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    return (
        <React.Fragment>
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-sm-4 col-md-3 m-0 p-0 pe-sm-2'}>
                    <FormInput
                        name={'title'}
                        detailedLabel={'Title'}
                        required={true}
                        value={data.title}
                        type={'select'}
                        options={TITLE_OPTIONS}
                        onChange={(value) => onChange('title', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-sm-4 col-md m-0 p-0 ps-sm-2 pe-sm-2'}>
                    <FormInput
                        name={'first_name'}
                        detailedLabel={'First name'}
                        required={true}
                        value={data.first_name}
                        type={'text'}
                        onChange={(value) => onChange('first_name', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-sm-4 col-md m-0 p-0 ps-sm-2'}>
                    <FormInput
                        name={'last_name'}
                        detailedLabel={'Last name'}
                        required={true}
                        value={data.last_name}
                        type={'text'}
                        onChange={(value) => onChange('last_name', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
            <FormInput
                name={'email'}
                detailedLabel={'Email address'}
                required={true}
                value={data.email}
                type={'email'}
                onChange={(value) => onChange('email', value)}
                disabled={disabled}
                error={errors}
            />
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-sm-4 col-md-3 m-0 p-0 pe-sm-2'}>
                    <FormInput
                        name={'phone_prefix'}
                        detailedLabel={'Phone prefix'}
                        required={true}
                        value={data.phone_prefix}
                        type={'select'}
                        options={PHONE_PREFIX_OPTIONS}
                        onChange={(value) => onChange('phone_prefix', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-sm-8 col-md-9 m-0 p-0 ps-sm-2'}>
                    <FormInput
                        name={'phone_number'}
                        detailedLabel={'Phone number'}
                        required={true}
                        value={data.phone_number}
                        type={'text'}
                        onChange={(value) => onChange('phone_number', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
            <FormInput
                name={'account_type'}
                detailedLabel={'Please select an account type'}
                required={true}
                value={data.account_type}
                type={'select'}
                options={ISA_TYPES}
                onChange={(value) => onChange('account_type', value)}
                disabled={disabled}
                error={errors}
            />
            <div className={"form-input-container"}>
                <Checkbox
                    name={'service_mail_email_phone_sms_opt_in'}
                    label={('By submitting your details, you agree to be contacted through mail, e-mail, phone or SMS by Akoni with the view of providing you with their commercial communications in accordance with our privacy policy available here. You confirm that you have read and agreed to our <a href="'+SE_BE_TERMS_AND_CONDITIONS+'" target="_blank">T&Cs</a> and <a href="'+SE_PRIVACY_POLICY+'" target="_blank">Privacy Policy</a>')}
                    checked={data.service_mail_email_phone_sms_opt_in === true || data.service_mail_email_phone_sms_opt_in === 'true' || data.service_mail_email_phone_sms_opt_in === 1 || data.service_mail_email_phone_sms_opt_in === '1'}
                    onChange={(value) => onChange('service_mail_email_phone_sms_opt_in', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.service_mail_email_phone_sms_opt_in ? errors.service_mail_email_phone_sms_opt_in : null} />
            </div>
        </React.Fragment>
    );
}

export default Details;
